import { Db } from 'mongodb'
import { schema, types } from 'papr'
import { PROJECT_DELETION_TTL } from '../shared/constants'

const collectionName = 'docsApiReferences'

export const docsApiReferenceSchema = schema(
	{
		projectId: types.objectId({ required: true }),
		apiReferenceId: types.objectId({ required: true }),
		versionId: types.objectId({ required: true }),
		/**
		 * The swagger definition of the API after the validation from `oas-normalize`
		 * compressed with gzip and saved as a base64 string.
		 */
		definition: types.string({ required: true }),
		/**
		 * The time when the api reference was soft deleted.
		 * User can request to restore the api reference for a small duration. After that, the api reference will be permanently deleted.
		 */
		deletedAt: types.date(),
	},
	{
		timestamps: true,
	},
)

export const createDocsProjectApiReferenceIndex = async (db: Db) => {
	await db.createIndex(
		collectionName,
		{
			deletedAt: 1,
		},
		{
			expireAfterSeconds: PROJECT_DELETION_TTL,
		},
	)
}

export type DocsApiReferenceDocument = (typeof docsApiReferenceSchema)[0]
export type DocsApiReferenceSchemaOptions = (typeof docsApiReferenceSchema)[1]
